// extracted by mini-css-extract-plugin
module.exports = {"container":"natalChild_container__2GXz-","title":"natalChild_title__2n2C2","box":"natalChild_box__bSclY","insta":"natalChild_insta__2CaVV"};